import getWidthAndHeightOfImageFile from './getWidthAndHeightOfImageFile';
import useImageSizeValidationByContentSettings from './useImageSizeValidationByContentSettings';
import isFileImage from './isFileImage';

const useImageFileValidate = (minimumResolution, maximumResolution) => {
  const [assertImageSize, assertFileIsNotImage] = useImageSizeValidationByContentSettings(minimumResolution, maximumResolution);

  const validateFile = async file => {
    if (!isFileImage(file)) {
      return assertFileIsNotImage();
    }

    if (file.type === 'image/svg+xml' || file.type === 'image/tiff') {
      // svg does not have resolution
      return true;
    }

    const { width, height } = await getWidthAndHeightOfImageFile({ file });
    file.width = width;
    file.height = height;

    return assertImageSize(file);
  };

  return { validateFile };
};

export default useImageFileValidate;
